import { CONTACT_DEFAULT_AVATAR } from '../constants/images';
import type { TContactFormValues } from './types';

export type TBuildCreateContactBodyOptions = {
    createdBy: string;
};

export function buildCreateContactBody(
    values: TContactFormValues,
    options: TBuildCreateContactBodyOptions
): Record<string, unknown> {
    const body: Record<string, unknown> = {
        name: values.name.trim(),
        store: values.store,
        createdBy: options.createdBy,
        countryCode: values.countryCode,
        image: values.image,
    };

    if (values.email.trim()) body.email = values.email.trim();
    if (values.phone.trim()) body.phone = values.phone.trim();
    if (values.secondaryPhone.trim()) {
        body.secondaryPhone = values.secondaryPhone.trim();
    }
    if (values.employment.trim()) body.employment = values.employment.trim();
    if (values.notes.trim()) body.notes = values.notes.trim();
    if (options?.createdBy) body.users = [options.createdBy];
    body.image = values.image || CONTACT_DEFAULT_AVATAR;

    return body;
}
